<script setup lang="ts">
import { computed } from "vue";
import { NodeViewWrapper } from "@tiptap/vue-3";
import type { NodeViewProps } from "@tiptap/vue-3";

const { node, updateAttributes } = defineProps<NodeViewProps>();

const startResize = (event: MouseEvent) => {
  const startX = event.clientX;
  const startWidth = parseInt(node.attrs.width || "300", 10);

  const onMouseMove = (moveEvent: MouseEvent) => {
    const delta = moveEvent.clientX - startX;
    const newWidth = Math.max(50, startWidth + delta);
    updateAttributes({ width: `${newWidth}px` });
  };

  const onMouseUp = () => {
    window.removeEventListener("mousemove", onMouseMove);
    window.removeEventListener("mouseup", onMouseUp);
  };

  window.addEventListener("mousemove", onMouseMove);
  window.addEventListener("mouseup", onMouseUp);
};

const imageStyle = computed(() => ({
  width: node.attrs.width,
  display: "block",
  margin: node.attrs.align === "left" ? "0 auto 0 0" : node.attrs.align === "right" ? "0 0 0 auto" : "0 auto",
}));
</script>
<template>
  <NodeViewWrapper as="div" style="position: relative; display: inline-block">
    <img :src="node.attrs.src" :style="imageStyle" />
    <span class="resize-handle" @mousedown.prevent="startResize">
      <div class="resize-handle-icon">
        <svg viewBox="0 0 12 12" width="12" height="12">
          <path d="M0,12 L12,0" stroke="#FFFFFF" stroke-width="2" />
          <path d="M8,12 L12,8" stroke="#FFFFFF" stroke-width="2" />
        </svg>
      </div>
    </span>
  </NodeViewWrapper>
</template>

<style scoped>
.resizable-image-wrapper {
  position: relative;
  display: inline-block;
  max-width: 100%;
  border: 1px solid transparent;

  &:hover {
    border: 1px solid #ccc;
  }
}

.resizable-image {
  display: block;
  max-width: 100%;
  height: auto;
  pointer-events: none;
  user-select: none;
}

.resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 12px;
  height: 12px;
  border-radius: 2px;
  cursor: se-resize;
  z-index: 10;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
}

.resize-handle-icon {
  position: absolute;
  right: 2px;
  bottom: 2px;
  width: 12px;
  height: 12px;
  cursor: se-resize;
  z-index: 10;

  svg {
    display: block;
  }
}
</style>
